import {
  correctVariableType
} from './correctVariableType.js';

export function getQueryParameters() {
  if (!location || !location.search || !location.search.length) return false;
  let queryParams = {};
  if (URLSearchParams) {
    const params = new URLSearchParams(location.search);
    for (const key of params.keys()) {
      queryParams[key] = params.get(key);
    }
  } else {
    queryParams = JSON.parse('{"' + decodeURI(location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
  }
  Object.keys(queryParams).forEach(qp => {
    if (
      ['active_color', 'base_color', 'inactive_color'].includes(qp) &&
      queryParams[qp].chatAt(0) !== '#'
    ) {
      queryParams[qp] = "#" + (queryParams[qp]);
    } else {
      queryParams[qp] = correctVariableType(queryParams[qp]);
    }
  });
  return queryParams;
};